import * as api from "../../../api";
import { buildAlertWithLocalizedMessages } from "../..";
import { jsError } from "../../../common/utils";
/* export * from "./authentication"; */

export const getLanguage = id => {
  return dispatch => {
    dispatch({ type: "GET_LANGUAGE_LOADING" });
    api
      .languageGet(id)
      .then(resp => {
        dispatch(operationSucceeded(resp.data));
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "FetchLanguageErrorAlertTitle",
          "Virhe kielitaidon lukemisessa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const operationSucceeded = data => ({
  type: "GET_LANGUAGE_SUCCEEDED",
  payload: { language: data },
});

const operationFail = () => ({
  type: "GET_LANGUAGE_FAIL",
});
